__turbopack_context__.v({
  "btn": "Default-module__4MFaTW__btn",
  "btnWrapper": "Default-module__4MFaTW__btnWrapper",
  "contentWrapper": "Default-module__4MFaTW__contentWrapper",
  "wrapper": "Default-module__4MFaTW__wrapper",
});
